import React from 'react';
import Navbar from './Navbar';
import '../styles.css';

const AboutPage = () => {
    return (
        <div>
            <div className="page-content">
                <h1>About Us</h1>
                <p>
                    Welcome to Egerton FreeMarket, a dedicated platform designed to help Egerton University students buy and sell items at affordable prices. Our website aims to create a vibrant community where students can freely trade goods and services, making university life more convenient and cost-effective. Whether you're looking to find a bargain or clear out some space, Egerton FreeMarket is here to support your needs with ease and efficiency.
                </p>
                <p>
                    Our mission is to facilitate seamless transactions while fostering a sense of community and collaboration among students. We believe in empowering students by providing a platform that simplifies the buying and selling process and ensures that everyone has access to great deals.
                </p>
            </div>
        </div>
    );
};

export default AboutPage;
